import { DecimalInput } from "@hulahoop/ui";
import { NUMBER_LOCALE } from "@/utils/formatUtils";

export function DecimalUnitInput({
  value,
  onValueChange,
  label,
  unit,
  placeholder,
  scale,
  minimumFractionDigits,
  min,
  max,
  step,
  largeStep,
  showSteppers,
}: {
  value: string | null;
  onValueChange: (value: string) => void;
  label: string;
  unit: string;
  placeholder?: string;
  scale: number;
  minimumFractionDigits: number;
  min?: string;
  max?: string;
  step?: string;
  largeStep?: string;
  showSteppers?: boolean;
}) {
  return (
    <div className="flex min-w-0 items-center gap-1.5">
      <DecimalInput
        locale={NUMBER_LOCALE}
        value={value || null}
        onValueChange={(next) => onValueChange(next ?? "")}
        placeholder={placeholder}
        min={min}
        max={max}
        step={step}
        largeStep={largeStep}
        showSteppers={showSteppers}
        scale={scale}
        minimumFractionDigits={minimumFractionDigits}
        aria-label={label}
        className="min-w-0 flex-1"
      />
      <span className="shrink-0 text-muted-foreground">{unit}</span>
    </div>
  );
}
